import React, { useState, useRef, useEffect } from "react";
import Rodal from "rodal";
import "./AgbModal.css";
import agbContent from "./agb-modal.json";
import YellowButton from "../Yellow-Button/Yellow-Button";

interface AgbModalProps {
  visible: boolean;
  onAccept: () => void;
}

const AgbModal = ({ visible, onAccept }: AgbModalProps) => {
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    if (contentRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
      // Consider "scrolled to bottom" when within 10px of the bottom
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
      if (isAtBottom && !hasScrolledToBottom) {
        setHasScrolledToBottom(true);
      }
    }
  };

  const formatText = (text: string) => {
    return text.split("\n").map((item, i) => {
      return <p key={i}>{item}</p>;
    });
  };

  const rodalStyle = {
    height: "100vh",
    width: "100vw",
    padding: 0,
    backgroundColor: "transparent",
  };

  return (
    <Rodal
      visible={visible}
      animation={"slideUp"}
      duration={500}
      customStyles={rodalStyle}
      className="agb-modal"
      showMask={true}
      showCloseButton={false}
      onClose={() => {}}
    >
      <div className="agb-modal-container">
        <div className="agb-modal-header">
          <h2>Allgemeine Geschäftsbedingungen</h2>
          <p className="agb-modal-subtitle">
            Bitte lesen Sie die folgenden Bedingungen vollständig durch und
            scrollen Sie bis zum Ende.
          </p>
        </div>

        <div
          className="agb-modal-content"
          ref={contentRef}
          onScroll={handleScroll}
        >
          {agbContent.map((item: any, key) => (
            <div key={key} className="agb-section">
              <h3 className="agb-section-title">{item.title}</h3>
              <div className="agb-section-content">
                {formatText(item.description)}
              </div>
            </div>
          ))}

          <div className="agb-scroll-indicator">
            {!hasScrolledToBottom && (
              <p className="agb-scroll-text">
                ↓ Bitte scrollen Sie bis zum Ende, um die Bedingungen zu
                akzeptieren ↓
              </p>
            )}
          </div>
        </div>

        <div className="agb-modal-footer">
          <YellowButton
            label="Bedingungen akzeptieren"
            disabled={!hasScrolledToBottom}
            onClick={onAccept}
          />
          {!hasScrolledToBottom && (
            <p className="agb-disabled-text">
              Bitte lesen Sie alle Bedingungen durch, um fortfahren zu können.
            </p>
          )}
        </div>
      </div>
    </Rodal>
  );
};

export default AgbModal;
